import { db } from "../firebase";
import { doc, getDoc, runTransaction, setDoc } from "firebase/firestore";
import { apDungMauMa, khoaBoDem, QUY_TAC_MAC_DINH } from "../lib/quyTacMaChuVuon";

const DOC_QUY_TAC = doc(db, "caiDat", "quyTacMaChuVuon");
const boDemDoc = (khoa) => doc(db, "boDemMaChuVuon", khoa);

export const quyTacMaChuVuonApi = {
  async layQuyTac() {
    const snap = await getDoc(DOC_QUY_TAC);
    return { ...QUY_TAC_MAC_DINH, ...(snap.exists() ? snap.data() : {}) };
  },

  async luuQuyTac(quyTac) {
    await setDoc(DOC_QUY_TAC, quyTac, { merge: true });
  },

  // Tăng bộ đếm STT theo khoá (Firestore transaction để tránh 2 nhân viên
  // tạo cùng lúc bị trùng STT), trả về giá trị STT vừa cấp.
  async tangBoDem(khoa) {
    return runTransaction(db, async (tx) => {
      const ref = boDemDoc(khoa);
      const snap = await tx.get(ref);
      const stt = (snap.exists() ? snap.data().soHienTai : 0) + 1;
      tx.set(ref, { soHienTai: stt });
      return stt;
    });
  },

  // Đặt thẳng bộ đếm (dùng khi "Tạo lại mã hàng loạt" để đồng bộ bộ đếm với
  // STT lớn nhất vừa gán, tránh lần tạo mới tiếp theo bị trùng STT).
  async datBoDem(khoa, gtri) {
    await setDoc(boDemDoc(khoa), { soHienTai: gtri });
  },

  async sinhMa({ loaiChuVuon, tinhMa, xaMa }) {
    const quyTac = await quyTacMaChuVuonApi.layQuyTac();
    const khoa = khoaBoDem({ loaiChuVuon, tinhMa, xaMa });
    const stt = await quyTacMaChuVuonApi.tangBoDem(khoa);
    const mau = loaiChuVuon === "nhan_vien" ? quyTac.mauNhanVien : quyTac.mauThuong;
    return apDungMauMa(mau, { tinh: tinhMa, xa: xaMa, stt, soChuSoStt: quyTac.soChuSoStt });
  },
};
